export default {
  productList: {
    title: 'Chemical List',
    description:
      'Please use the Chemical List below to search for the products you need. If you cannot find a product or need further information, please',
    sendInquiry: 'send us an inquiry',
    descriptionSuffix: '.',
    searchPlaceholder: 'Enter Chemical Name',
    searchBtn: 'Chemical Search',
    showing: 'Showing',
    of: 'of',
    resultsSuffix: 'products',
    col: {
      name: 'Chemical Name',
      formula: 'Chemical Formula / MW (FW)',
      hsCode: 'HS Code',
      application: 'What is Your Application?',
      contact: 'Contact',
    },
    askDetails: 'Ask for Details',
    noProducts: 'No products found',
    noProductsHint: 'Try a different search term or letter',
    clearSearch: 'Clear Search',
    footnote:
      'This chemical list shows a selection of high-quality chemicals and minor metals distributed by Daishin Corporation. In some cases, we are not able to provide a quote for items due to availability (supply-demand balance), the chemical manufacturer\'s export policy to a specific country, or other reasons. Thank you in advance for your understanding.',
    cta: {
      title: "Can't find what you're looking for?",
      description: 'Contact us with your specific requirements and we\'ll help you source the right chemicals.',
      btn: 'Get in Touch',
    },
  },
};
